import React, { useState } from 'react'
import classes from "./style.module.scss";

const CustomerInformation = ({type,email, mobile,name }) => {

    return (
        <>
            <div className={`${classes.enquiryCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Customer Details
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                    <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Customer Name</div>
                            <div className={`${classes.infoValue}`}>{name}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Customer type</div>
                            <div className={`${classes.infoValue}`}>{type}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Email</div>
                            <div className={`${classes.infoValue}`}>{email}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Mobile number</div>
                            <div className={`${classes.infoValue}`}>{mobile}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerInformation